
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/display-video",
      function () {
        return require("private-next-pages/destinations/display-video.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/display-video"])
      });
    }
  